import gallery2 from "../../media/images/gallery2.jpeg";
import gallery3 from "../../media/images/updo.jpeg";
import gallery4 from "../../media/images/gallerypic.jpeg";
import gallery6 from "../../media/images/gallery6.jpeg";
import gallery14 from "../../media/images/jojjo.jpeg";
import updo from "../../media/images/Gallery/updo.jpg";
import updo1 from "../../media/images/Gallery/updo1.jpg";
import updo2 from "../../media/images/Gallery/updo3.jpg";
import updo3 from "../../media/images/Gallery/updos_2.png";
import curls from "../../media/images/Gallery/curls.jpg";
import halfup from "../../media/images/Gallery/halfup.jpg";

export const gallery = [
  {
    id: 0,
    url: gallery3,
    category: "hair",
  },
  {
    id: 1,
    url: gallery2,
    category: "hair",
  },
  {
    id: 2,
    url: gallery4,
    category: "hair",
  },
  {
    id: 3,
    url: gallery6,
    category: "hair",
  },
  {
    id: 4,
    url: gallery14,
    category: "makeup",
  },
  {
    id: 5,
    url: updo,
    category: "hair",
  },
  {
    id: 6,
    url: updo1,
    category: "hair",
  },
  {
    id: 7,
    url: updo2,
    category: "hair",
  },
  {
    id: 9,
    url: updo3,
    category: "hair",
  },
  {
    id: 10,
    url: curls,
    category: "hair",
  },
  {
    id: 11,
    url: halfup,
    category: "hair",
  },
];
